/* eslint-disable unicorn/filename-case */
import axios, { AxiosResponse } from 'axios';

import { endpoints } from '@/API/endpoints';
import { getFormError } from '@/helpers/getResponseErrors';
import { FormDataType, ISsoProvidersResponse } from '@/types';

const AuthApi = {
	async login(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlToken, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async getConfirmCode(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlGetConfirmCode, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async verifyConfirmCode(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlVerifyConfirmCode, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async resetPassword(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlResetPassword, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async getSsoProviders() {
		try {
			const response: AxiosResponse<ISsoProvidersResponse> = await axios.get(
				endpoints.ssoProviders
			);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async getSsoUrl(slug: string) {
		try {
			const response: AxiosResponse<{
				authorization_url: string;
				state_ttl_seconds: number;
			}> = await axios.get(`${endpoints.ssoUrl}?slug=${slug}`);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async ssoLogin(code: string, state: string) {
		try {
			const response = await axios.post(endpoints.ssoLogin, { code, state });
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},
};

export { AuthApi };
